export class SyncStrategyRegistry {
    #strategies = new Map();
    register(domain, strategy) {
        if (this.#strategies.has(domain))
            throw new Error(`Sync strategy for ${domain} is already registered`);
        this.#strategies.set(domain, strategy);
    }
    get(domain) {
        return this.#strategies.get(domain);
    }
    require(domain) {
        const strategy = this.get(domain);
        if (strategy === undefined)
            throw new Error(`No sync strategy registered for ${domain}`);
        return strategy;
    }
    domains() {
        return [...this.#strategies.keys()].sort();
    }
}
//# sourceMappingURL=registry.js.map